export default __webpack_public_path__ + "static/media/7.2e7a2ad9.png";